import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tCentro/theme/design";
import { css } from "styled-components";

Object.assign(addToListLinkStyles, {
    wrapper: {
        css: css`
            margin-bottom: 14px;
            text-align: center;
            justify-content: flex-end;
            div {
                justify-content: flex-end;
            }

            button {
                display: inline-flex;
                justify-content: center;
                align-items: center;
                width: 48px;
                height: 48px;
                background: ${COLORS.white};
                border: 2px solid ${COLORS.background.grayShade};
                border-radius: 40px;
                &:hover {
                    background: ${getColor("secondary")};
                    border-color: ${getColor("secondary")};
                    svg {
                        fill: ${COLORS.white};
                        path {
                            fill: ${COLORS.white};
                        }
                    }
                }

                > span {
                    width: 24px;
                    height: 24px !important;
                    &:hover {
                        color: ${COLORS.white};
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                width: 20px;
                                height: 20px !important;
                            `,
                            css`
                                width: 20px;
                                height: 20px !important;
                            `,
                            css`
                                width: 20px;
                                height: 20px !important;
                            `,
                            null,
                            null,
                        ])}
                }
            }
            div > svg {
                height: 24px !important;
                &:hover {
                    fill: ${COLORS.white};
                    path {
                        fill: ${COLORS.white};
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 20px;
                            height: 20px !important;
                        `,
                        css`
                            width: 20px;
                            height: 20px !important;
                        `,
                        css`
                            width: 20px;
                            height: 20px !important;
                        `,
                        null,
                        null,
                    ])}
            }
            button > span span:last-child {
                display: none;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            margin-bottom: 0px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
});
